import React, { ButtonHTMLAttributes } from 'react';

const SecondaryButton: React.FC<
  ButtonHTMLAttributes<HTMLButtonElement> & { btnType?: 'default' | 'outline' }
> = props => {
  const { className, btnType, ...otherProps } = props;
  const type = {
    default: 'border-none',
    outline: 'border border-primary-2 rounded-lg'
  };
  return (
    <button
      data-testid="secondary-button"
      className={`
          cursor-pointer w-full text-center font-medium px-3 py-2 sm:py-0 text-base text-gray-600
          ${type[btnType || 'outline']} ${className}`}
      {...otherProps}
    >
      {props.children}
    </button>
  );
};
export default SecondaryButton;
